export default "__VITE_ASSET__CvOH4ZKk__"